import { ReactElement } from 'react'

export const imageSizes = {
  twitter: 69,
  trustpilot: 120,
  reddit: 147,
} as const

export enum ECoinPageParagraphTypes {
  ul = 'ul',
}

export interface ICoinPageBlogCard {
  link: string
  image: string
  imageAlt: string
}

export type TCoinPageTextElement = string | ReactElement

export interface ICoinPageQuestion {
  title: string
  answer: string
}

export interface ICoinPageData {
  title: string
  description: string
  metaDescription?: string
  metaTitle?: string
  useTicker?: boolean
  h1?: (
    t: (key: unknown) => any,
    locale?: string,
    replacePlaceholders?: (text: string, variables: Record<string, any>) => string
  ) => JSX.Element | ReactElement
  videoId?: string
  videoTitle?: string
  questionsBlock: {
    image?: string
    questions: ICoinPageQuestion[]
  }
  whatIs: {
    text: string[]
    slides?: any
    paragraphs?: Array<{
      title: string
      text: TCoinPageTextElement[]
      type?: ECoinPageParagraphTypes
    }>
    blogCards?: ICoinPageBlogCard[]
  }
  background?: { data: { id: number; attributes: { url: string } } }
  howLend?: {
    title?: string
    steps?: Record<string, Record<string, string>>
  }
}
